import { render } from "./ApiKeys.vue?vue&type=template&id=126036c7&scoped=true"
import script from "./ApiKeys.vue?vue&type=script&lang=js"
export * from "./ApiKeys.vue?vue&type=script&lang=js"

import "./ApiKeys.vue?vue&type=style&index=0&id=126036c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126036c7"]])

export default __exports__